export const makeAsyncQueue = ({activeLimit=2}:{
    activeLimit ?: number,
}={}) => {
    const queue:Function[] = [];
    let activeCount = 0;

    const add = <Args extends any[], AwaitedReturn>(fn:(...args:Args) => Promise<AwaitedReturn>, args:Args): Promise<AwaitedReturn> => {
        return new Promise((resolve, reject) => {
            queue.push(async () => {
                try {
                    resolve(await fn(...args));
                } catch (error) {
                    reject(error);
                }
            });
            run();
        });
    };

    const run = async () => {
        if (queue.length > 0 && activeCount < activeLimit) {
            activeCount++;
            await queue.shift()();
            activeCount--;
            run();
        }
    };

    const wrap = <Args extends any[], AwaitedReturn>(fn:(...args:Args) => Promise<AwaitedReturn>): (...args:Args) => Promise<AwaitedReturn> => (
        (...args) => add(fn, args)
    );

    return {add, wrap};
};

